import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Test from './views/Test.vue'
import AdminLogin from './views/Admin/AdminLogin.vue'
import GameClient from './views/GameClient/GameClient.vue'
import ChooseHostMode from './views/GameHost/ChooseHostMode.vue'
import HostManager from './views/GameHost/HostManager.vue'
import PublicTeamList from './views/GameHost/PublicTeamList.vue'
import ScoreTeamAnswers from './views/GameHost/ScoreTeamAnswers.vue'
import store from './store'

Vue.use(Router)

 const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      props: (route) => ({ code: route.query.code, apiMessage:  route.query.apiMessage})
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/client/:code',
      name: 'GameClient',
      component: GameClient,
      props: true
    },
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/host/mode',
      name: 'ChooseHostMode',
      component: ChooseHostMode
    },
    {
      path: '/host/teams/:code',
      name: 'PublicTeamList',
      component: PublicTeamList,
      props: true
    },
    {
      path: '/host/:code',
      name: 'HostManager',
      component: HostManager,
      props: true
    },
    {
      path: '/host/:gameOccurrenceId/score-answers/:questionId',
      name: 'ScoreTeamAnswers',
      component: ScoreTeamAnswers,
      props: true
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.fullPath.startsWith("/host")){
    if(store.getters['admin/token'] === "") {
      next({name: "AdminLogin"})
    }
  }

  next();
})

export default router